(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3629],{

/***/ 10110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76745);
/* harmony import */ var _en_US__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24457);



const useLocale = (componentName, defaultLocale) => {
  const fullLocale = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_context__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
  const getLocale = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    var _a;
    const locale = defaultLocale || _en_US__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[componentName];
    const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
  }, [componentName, defaultLocale, fullLocale]);
  const getLocaleCode = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
    // Had use LocaleProvide but didn't set locale
    if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) {
      return _en_US__WEBPACK_IMPORTED_MODULE_2__/* ["default"].locale */ .Z.locale;
    }
    return localeCode;
  }, [fullLocale]);
  return [getLocale, getLocaleCode];
};
/* harmony default export */ __webpack_exports__["Z"] = (useLocale);

/***/ }),

/***/ 80110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ genCompactItemStyle; }
/* harmony export */ });
// handle border collapse
function compactItemBorder(token, parentCls, options, prefixCls) {
  const {
    focusElCls,
    focus,
    borderElCls
  } = options;
  const childCombinator = borderElCls ? '> *' : '';
  const hoverEffects = ['hover', focus ? 'focus' : null, 'active'].filter(Boolean).map(n => `&:${n} ${childCombinator}`).join(',');
  return {
    [`&-item:not(${parentCls}-last-item)`]: {
      marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
    },
    [`&-item:not(${prefixCls}-status-success)`]: {
      zIndex: 2
    },
    '&-item': Object.assign(Object.assign({
      [hoverEffects]: {
        zIndex: 3
      }
    }, focusElCls ? {
      [`&${focusElCls}`]: {
        zIndex: 3
      }
    } : {}), {
      [`&[disabled] ${childCombinator}`]: {
        zIndex: 0
      }
    })
  };
}
// handle border-radius
function compactItemBorderRadius(prefixCls, parentCls, options) {
  const {
    borderElCls
  } = options;
  const childCombinator = borderElCls ? `> ${borderElCls}` : '';
  return {
    [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
      borderRadius: 0
    },
    [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function genCompactItemStyle(token, options = {
  focus: true
}) {
  const {
    componentCls
  } = token;
  const {
    componentCls: customizePrefixCls
  } = options;
  const mergedComponentCls = customizePrefixCls || componentCls;
  const compactCls = `${mergedComponentCls}-compact`;
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemBorder(token, compactCls, options, mergedComponentCls)), compactItemBorderRadius(mergedComponentCls, compactCls, options))
  };
}

/***/ }),

/***/ 67453:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/search",
      function () {
        return __webpack_require__(37394);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68806);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85673);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11004);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61906);
/* harmony import */ var src_utils_apollo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18329);
/* harmony import */ var src_components_guide_Bottom__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72962);
/* harmony import */ var src_components_guide_Header__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98878);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88595);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_13__);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n          query {\n            tsafelyArticles(\n              filters: { title: { containsi: "',
        '" }, tsafely_category: { name: { in: ["',
        '", "',
        '"] } } }\n              pagination: { page: ',
        ", pageSize: ",
        ' }\n              sort: "updatedAt:desc"\n            ) {\n              data {\n                id\n                attributes {\n                  title\n                  slug\n                }\n              }\n              meta {\n                pagination {\n                  page\n                  pageSize\n                  pageCount\n                  total\n                }\n              }\n            }\n          }\n        '
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}












const Search = ()=>{
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("common");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [current, setCurrent] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(1);
    const pageSize = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>10, []);
    const [total, setTotal] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0);
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const [searchText, setSearchText] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const inputDom = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        let ios = "ios-guide";
        let android = "android-guide";
        if (locale && locale != "en") {
            if (locale == "it-ch") {
                ios = ios + "-it";
                android = android + "-it";
            } else {
                ios = ios + "-" + locale;
                android = android + "-" + locale;
            }
        }
        (0,src_utils_apollo__WEBPACK_IMPORTED_MODULE_7__/* .logQuery */ .g)({
            query: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_10__/* .gql */ .Ps)(_templateObject(), router.query.query, ios, android, current, pageSize)
        }).then((res)=>{
            setData(res.data.tsafelyArticles.data);
            setTotal(res.data.tsafelyArticles.meta.pagination.total);
        });
        ;
    }, [
        current,
        pageSize,
        locale,
        router.query.query
    ]);
    const onEnter = (event)=>{
        if (event.key === "Enter") {
            router.push("/guide/search?query=" + searchText);
            inputDom.current.blur();
        }
    };
    const onChange = (page)=>{
        setCurrent(page);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_guide_Header__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("main", {
                className: "max-w-[1200px] min-h-[calc(var(--vh)*100-380px)] mx-auto Bld:min-h-[calc(var(--vh)*100-360px)] Bxl:px-[16px] py-[20px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "w-full flex Bld:flex-col justify-between items-center Bld:items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                items: [
                                    {
                                        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: "/guide",
                                            children: t("Guide")
                                        })
                                    },
                                    {
                                        title: t("Search")
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "w-[300px] Bld:w-full Bld:mt-[10px] h-[40px] bg-[#FFF] border border-[rbg(121,121,121)] rounded-[41px] outline-none px-[24px] flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "/images/contacts/search.svg",
                                        width: 20,
                                        height: 0,
                                        alt: "search"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                        ref: inputDom,
                                        className: "ml-[10px] flex-1 outline-none placeholder:text-[rgb(129,129,135)]",
                                        placeholder: t("Search"),
                                        value: searchText,
                                        onChange: (e)=>setSearchText(e.target.value),
                                        onKeyPress: onEnter
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                        className: "mt-[45px] text-[32px]",
                        children: t("Search results")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                        className: "text-[15px] text-[rgba(42,49,61,1)] mt-[10px]",
                        children: [
                            total,
                            " ",
                            t("results for"),
                            ' "',
                            router.query.query,
                            '"'
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "mt-[20px] flex flex-col Blds:w-[500px]",
                        children: [
                            data.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "py-[20px] border-b",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "/guide/" + item.attributes.slug,
                                        className: "text-[16px] Bld:text-[15px] text-[#222] hover:text-[#2a99ff] cursor-pointer",
                                        children: item.attributes.title
                                    })
                                }, i)),
                            total !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().pagination), " mt-[30px]"),
                                current: current,
                                pageSize: pageSize,
                                total: total,
                                onChange: onChange
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_guide_Bottom__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Search);


/***/ }),

/***/ 88595:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article":"guide_article__cxmMw","pagination":"guide_pagination__uhlzl"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,1954,1033,8914,3368,1675,1664,3573,2697,8791,1004,2068,7743,5678,1709,9774,2888,179], function() { return __webpack_exec__(67453); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);